import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

//import { pushHistoryWithOwner } from '../../utils/routing';

import Error from '../Error/Error';

import { COMMON_ERROR } from '../../translations';
/*import { 
    SEARCH_USERS_RESULT
} from './translations';*/

import styles from './TableMine.module.css';
import { getUserRole } from '../../utils/functions';


export default class TableMine extends Component {
    static propTypes = {
        data: PropTypes.shape({
            isError: PropTypes.bool,
            isFetching: PropTypes.bool,
            isFetchedAll: PropTypes.bool,
    
            count: PropTypes.number,
            offset: PropTypes.number,
            users: PropTypes.arrayOf(PropTypes.shape({
                spaId: PropTypes.number,
                spaUsername: PropTypes.string,
                id: PropTypes.number,
                username: PropTypes.string,
                role: PropTypes.string,
                readOnly: PropTypes.bool
            })),
        }),
        
        isDisplay: PropTypes.bool,
    }

    handleClickBrowse = (userId) => {
        this.props.onClickBrowse(userId);
    }

    renderButtonBrowse = (spaId) => {
        return (
            <span className={classNames(styles.b_user, styles.b_btn)} onClick={() => this.handleClickBrowse(spaId)}>
                <img className={classNames(styles.btn_img, styles.btn_img__browse)} src="https://tankimods.net/static/portal/images/dot.gif" title="Обзор" alt="Обзор"/>
                &nbsp;Обзор
            </span>
        )
    }

    renderButtonDelete = () => {
        return getUserRole() === 'admin' ? (
                <span className={classNames(styles.b_user, styles.b_btn)}>
                    <img className={classNames(styles.btn_img, styles.btn_img__drop)} src="https://tankimods.net/static/portal/images/dot.gif" title="Обзор" alt="Обзор"/>
                    &nbsp;Удалить
                </span>
            ) : null
    }

    renderUser = (item) => {
        let userLink = `https://tanki.su/ru/community/accounts/${item.spaId}-${item.spaUsername}/`

        return (
            <tr key={item.username}>
                {item.spaUsername && item.id < 2000000000 ? 
                    <td className={styles.b_user}>
                        <Link to={userLink} state={{ lastUrl: document.location.href }}> 
                            {/*<!-- ko text: nickname -->*/}{item.spaUsername}{/*<!-- /ko --><!-- ko if: clanUrl !== '' --><!-- /ko --> */}
                        </Link>
                    </td> :
                    <td className={styles.b_user}>
                        {/*<!-- ko text: nickname -->*/}{item.spaUsername ? item.spaUsername : '-'}{/*<!-- /ko --><!-- ko if: clanUrl !== '' --><!-- /ko --> */}
                    </td>}
                <td data-bind="text: spaId">{item.spaId ? item.spaId : '-'}</td>
                <td data-bind="text: nickName">{item.username ? item.username : '-'}</td>
                <td data-bind="text: id">{item.id ? item.id : '-'}</td>
                <td data-bind="text: role">{item.role ? item.role : '-'}</td>
                <td data-bind="text: readOnly">{item.readOnly ? 'On' : 'Off'}</td>
                <td data-bind="btn">
                    {this.renderButtonBrowse(item.spaId)}
                    {this.renderButtonDelete()}
                </td>
            </tr>
        )
    }

    render() {
        /*let isClickableMods = true;
        if (this.props.data.users) {
            isClickableMods = true;
        }*/
        /*
        <th>Игровое имя</th>
        <th>Lesta ID</th>
        <th>Имя на сайте</th>
        <th>ID (на сайте)</th>
        <th>Игровой клиент</th>
        <th>Дата регистрации (Lesta)</th>
        <th>Активность на сайте</th>
        <th>Роль аккаунта</th>
        <th>Режим «Read Only»</th>
        <th>Моды</th>
        <th>Тикеты</th>
        <th>Комментарии</th>
        <th>Действие</th>

        <td className={styles.b_user}>
        <Link to="https://tanki.su/ru/community/accounts/40074718-McClayn/" state={{ lastUrl: document.location.href }}>mcclayn</Link>
        </td>
        <td data-bind="text: spaId">40074718</td>
        <td data-bind="text: nickName">ru_1</td>
        <td data-bind="text: id">1</td>
        <td data-bind="text: client">ru</td>
        <td data-bind="text: birthdayAcc">2015.02.27</td>
        <td data-bind="text: lastVisit">2025.02.23</td>
        <td data-bind="text: role">Admin</td>
        <td data-bind="text: readOnly">Off</td>
        <td className={styles.b_user} data-bind="text: countMods">
            <span onClick={(event) => {
                event.preventDefault()
                if (isClickableMods) {
                    //useNavigates('/search/?owner='+this.props.ownerId, this.props.ownerName)
                    pushHistoryWithOwner(this.props.history, this.props.ownerId, this.props.ownerName)
                }
            }}>1</span>
        </td>
        <td data-bind="text: countTickets">0</td>
        <td data-bind="text: countComments">0</td>
        <td data-bind="btn">
            <span className={classNames(styles.b_user, styles.b_btn)}>
                <img className={classNames(styles.btn_img, styles.btn_img__browse)} src="https://tankimods.net/static/portal/images/dot.gif" title="Обзор" alt="Обзор"/>
                &nbsp;Обзор
            </span>
            <span className={classNames(styles.b_user, styles.b_btn)}>
                <img className={classNames(styles.btn_img, styles.btn_img__drop)} src="https://tankimods.net/static/portal/images/dot.gif" title="Обзор" alt="Обзор"/>
                &nbsp;Удалить
            </span>
        </td>
        */
        let classNameTable = classNames(styles.t_table, {
            [styles.display]: !this.props.isDisplay,
        })

        if (this.props.data.isError) {
            return <Error>{COMMON_ERROR}</Error>
        }
        
        return this.props.data.users.length === 0 && !this.props.data.isFetching ? (
                null //<Error>{SEARCH_USERS_RESULT}</Error>
            ) : (
                <table className={classNameTable}>
                    <thead>
                        <tr>
                            <th>Игровое имя</th>
                            <th>Lesta ID</th>
                            <th>Имя на сайте</th>
                            <th>ID (на сайте)</th>
                            <th>Роль аккаунта</th>
                            <th>Режим «Read Only»</th>
                            <th>Действие</th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: mainList">
                        {/* {this.props.filtered.items.map((item)) => { this.renderItem(item)) }} */}
                        {this.props.data.users.map((item) => this.renderUser(item))}
                    </tbody>
                </table>
            )
    }
}
